<template>
  <div
    class="app-list"
    :class="{
      grid,
      'no-vertical-padding': noVerticalPadding,
      'with-border': withBorder,
      'no-side-padding': noSidePadding,
      'no-padding': noPadding,
      'horizontal-flow': horizontal,
    }"
    :style="{ 'margin-left': leftMargin }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppList',

  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },

    withBorder: {
      type: Boolean,
      default: false,
    },

    noVerticalPadding: {
      type: Boolean,
      default: false,
    },

    noSidePadding: {
      type: Boolean,
      default: false,
    },

    noPadding: {
      type: Boolean,
      default: false,
    },

    grid: {
      type: Boolean,
      default: false,
    },

    columns: {
      type: Number,
      default: 3,
    },

    leftMargin: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.app-list {
  list-style: none;
  // margin: #{math.div($defaultPadding, 2)} 0;
  margin: 0;
  padding-top: #{math.div($defaultPadding, 2)};
  padding-bottom: #{math.div($defaultPadding, 2)};

  &:empty {
    padding: 0;
  }

  &.no-vertical-padding {
    padding-top: 0;
    padding-bottom: 0;
  }

  &:not(.grid) {
    > .app-list-item {
      &:first-child {
        border-top: 0;
      }
    }
  }

  &.grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 115px);
    justify-content: space-around;
  }

  &.with-border {
    :deep(> .app-list-item) {
      border-top: 1px solid rgba(0, 0, 0, 0.12);
    }
  }

  &.no-side-padding {
    :deep(.app-list-item) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.no-padding {
    > .app-list-item {
      padding-left: 0;
      padding-right: 0;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}

.app-card {
  &:not(.no-padding) {
    > .app-list {
      $margin: -#{$defaultPadding};
      margin-left: $margin;
      margin-right: $margin;

      // &:only-child {
      //   margin-top: $margin;
      //   margin-bottom: $margin;
      // }
    }
  }
}
</style>
